<template>
  <div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>기본정보</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_1"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_0 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_0"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_2"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_3"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">조치일</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_4 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>부적합 보고서</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">발행번호</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_1 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">발행일자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_2 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">해당부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_3 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_3"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">발행사유</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_4 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-12 flex items-center">
          <div class="label-text mr-4">제목</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_5 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_5"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>발행부서</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6  ">
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">부적합 내용</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputC_1 }}</p>
          <ml-textarea
            placeholder="내용"
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_1"
            class="flex-1 w-full"
            rows="5"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputC_2 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">확인자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputC_3 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_3"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>회신부서</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6  ">
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">시정 내용 (시정조치/예방조치)</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_1 }}</p>
          <ml-textarea
            placeholder="• 원인 :
• 조치 :
• 첨부 :"
            :readonly="board.readonly"
            v-else
            v-model="form.inputD_1"
            class="flex-1 w-full"
            rows="5"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_2 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputD_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">확인자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_3 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputD_3"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>주관부서</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">최종처리 이행확인</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputE_1 }}</p>
          <action-type-a-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputE_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">재해형태</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputE_2 }}</p>
          <disaster-class-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputE_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">해당부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputE_3 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputE_3"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">검토자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputE_4 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputE_4"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>
    <file-upload-module
      :readonly="board.readonly"
      v-if="!isPrint"
      class="w-full mt-4"
      v-model="form.fileList"
    />
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import ShanghaiClassSelector from "@/components/ShanghaiClassSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import ActionTypeASelector from "../../../../components/selector/ActionTypeASelector.vue";
export default {
  name: "Write",
  components: {
    FileUploadModule,
    DateSelector,
    ShanghaiClassSelector,
    DisasterClassSelector,
    ActionTypeASelector
  },
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 =
          this.value && this.value.inputA_1
            ? this.value.inputA_1
            : this.board.projectTitle;
        this.form.inputA_2 =
          this.value && this.value.inputA_2
            ? this.value.inputA_2
            : this.board.writer.com_name;
        this.form.inputA_3 =
          this.value && this.value.inputA_3
            ? this.value.inputA_3
            : this.board.writer.name;
        this.form.inputA_0 =
          this.value && this.value.inputA_0
            ? this.value.inputA_0
            : this.board.writer.department;
      }
    },
    value(value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        this.form[key] = value[key];
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1;
        value.summary = {
          "최종처리 이행확인": [{ [this.form.inputE_1]: 1 }],
          "재해형태": [{ [this.form.inputE_2]: 1 }]
        }
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      form: {
        fileList: [],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",
        inputE_4: ""
      }
    };
  }
};
</script>

<style scoped>
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
}
.mt-component-form {
  margin-top: 20px;
}
</style>
